/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2024-05-21 (jhoward)
 *		- Add site.options.js to store site-specific options.
 *
 *	2024-05-21 (jhoward)
 *		- Add XDine hostnames to externalLinkWarning.internalHostnames in site.options.js.
 */
export default {
  externalLinkWarning: {
    enable: true,
    externalMessage: 'Peppermill is not responsible for the content of this external site.',
    internalMessage: 'You will be redirected to another of our websites.',
    dialogTitle: 'You are now exiting PeppermillReno.com',
    internalHostnames: [
      //booking hostnames
      'reserve1.peppermillcas.com',
      'reserve2.peppermillcas.com',
      'reserve3.peppermillcas.com',
      'booking.peppermillreno.com',
      'devbooking.peppermillreno.com',
      'booking.wvsparks.com',
      'devbooking.wvsparks.com',
      'booking.wendoverfun.com',
      'devbooking.wendoverfun.com',

      //main website hostnames
      'peppermillreno.com',
      'westernvillagesparks.com',
      'wvsparks.com',
      'wendoverfun.com',
      'apply.wendoverfun.com',
      'peppermillnightlife.com',
      'peppermillcareers.com',
      'peppermillresorts.com',
      'peppermilllasvegas.com',

      //xdine
      'peppermillchi.xdineapp.com',
      'peppermilloceano.xdineapp.com',
      'peppermillcafemilano.xdineapp.com',
      'peppermillbiscottis.xdineapp.com',
      'peppermillsportsdeli.xdineapp.com',
      'peppermillsabrosotaqueria.xdineapp.com',
    ]
  }
};